// extracted by mini-css-extract-plugin
module.exports = {"loader":"UiSpinner_loader__37gOG","load8":"UiSpinner_load8__25lez"};